import { createButton } from '../utils/create-button'
import { createImage } from '../utils/create-image'
import CONSTANTS from '../constants'

/**
 * @public
 * @function DrawButton
 * @description Draws button with specified ID
 * @param {String} elementId Element Id to draw the button on
 */
export const drawButton = (elementId) => {
  const element = document.getElementById(elementId)

  if (!element) {
    throw new Error(`Cannot find element by ID: ${elementId}`)
  }

  const imageSize = element.getAttribute('data-image-size')

  /**
   * @todo [Josh V] We need to make sure a static asset is done correctly here for the URL
   */
  const imageElement = createImage(document, CONSTANTS, imageSize)
  const buttonElement = createButton(document)

  buttonElement.appendChild(imageElement)
  element.appendChild(buttonElement)
}
